import { tv } from "../../../variants/tv.js";
const tableVariants = tv({
    base: 'divide-neutral-5 w-full border-separate border-spacing-0 divide-y',
    slots: {
        container: ''
    },
    variants: {
        bordered: {
            true: {
                base: 'rounded-xl',
                container: 'border-1 border-primary-5 overflow-hidden rounded-xl'
            }
        },
        scrollable: {
            true: {
                container: 'no-scrollbar overflow-auto'
            }
        }
    },
    defaultVariants: {
        bordered: false,
        scrollable: false
    }
});
const containerVariants = tv({
    variants: {
        bordered: {
            true: 'border-1 border-primary-5 overflow-hidden rounded-xl'
        },
        scrollable: {
            true: 'no-scrollbar overflow-auto'
        }
    },
    defaultVariants: {
        bordered: false,
        scrollable: false
    }
});
export { containerVariants, tableVariants };
